import { IData } from '../interface';

const render = (data: IData) => {
    const SYSTEM_SCRIPT_MAP = {
        '"CN"': '<!--<script src="https://www.recaptcha.net/recaptcha/api.js?render=6LcusCsaAAAAAI2bbBt7Zif88KWZSeFqqSPQAEw1"></script>-->',
        'CN': '<!--<script src="https://www.recaptcha.net/recaptcha/api.js?render=6LcusCsaAAAAAI2bbBt7Zif88KWZSeFqqSPQAEw1"></script>-->',
        '"EN"': '<!--<script src="https://www.recaptcha.net/recaptcha/api.js?render=6LcusCsaAAAAAI2bbBt7Zif88KWZSeFqqSPQAEw1"></script>-->',
        'EN': '<!--<script src="https://www.recaptcha.net/recaptcha/api.js?render=6LcusCsaAAAAAI2bbBt7Zif88KWZSeFqqSPQAEw1"></script>-->',
        '"EM"': '<!--<script src="https://www.recaptcha.net/recaptcha/api.js?render=6LcusCsaAAAAAI2bbBt7Zif88KWZSeFqqSPQAEw1"></script>-->',
        'EM': '<!--<script src="https://www.recaptcha.net/recaptcha/api.js?render=6LcusCsaAAAAAI2bbBt7Zif88KWZSeFqqSPQAEw1"></script>-->',
        '"JP"': '',
        'JP': '',
        '"TW"': '',
        'TW': '',
    };

    return SYSTEM_SCRIPT_MAP[data.SYSTEM] || '';
};

export default render;
